/*@ngInject*/
const FormConfigurationUtil = function ($rootScope, formViewerConstant, uuidUtil) {

    function findFieldStructureLocationById(targetFieldId, sourceFormStructure) {
        let result = null;

        function searchSections(sectionList, parentForm) {
            _.each(sectionList, function (section) {
                return searchRows(section.rowList, parentForm, section);
            });
        }

        function searchRows(rowList, parentForm, section) {
            _.each(rowList, function (row) {
                searchFields(row.fieldStructureList, parentForm, section, row);
                if (_.isNil(result) && !_.isEmpty(row.rowList) && !_.isNil(row.rowList[0])) {
                    searchFields(row.rowList[0].fieldStructureList, parentForm, section, row);
                }

                if (row.sectionList) {
                    searchSections(row.sectionList);
                }
            });
        }

        function searchFields(fieldStructureList, parentForm, section, row) {
            _.each(fieldStructureList, function (fieldStructure) {

                if (fieldStructure.fieldStructureId === targetFieldId) {
                    result = {
                        parentForm: parentForm,
                        parentSection: section,
                        parentRow: row,
                        fieldStructure: fieldStructure,
                        isRowRepeater: row.rowTemplate.rowRepeatable
                    };
                    return false;
                }

            });
        }

        searchSections(sourceFormStructure.sectionList, sourceFormStructure);

        return result;
    }

    function findSectionStructureLocationById(targetSectionId, sourceFormStructure) {
        let result = null;

        function searchSections(sectionList, parentForm) {
            _.each(sectionList, function (section) {
                if (section.sectionStructureId === targetSectionId) {
                    result = {
                        parentForm: parentForm,
                        sectionStructure: section
                    };
                }
                else {
                    searchRows(section.rowList, parentForm, section);
                }
            });
        }

        function searchRows(rowList) {
            _.each(rowList, function (row) {
                if (row.sectionList) {
                    searchSections(row.sectionList);
                }
            });
        }

        searchSections(sourceFormStructure.sectionList, sourceFormStructure);

        return result;
    }

    function findRowStructureLocationById(targetRowId, sourceFormStructure) {
        let result = null;

        function searchSections(sectionList, parentForm) {
            _.each(sectionList, function (section) {
                searchRows(section.rowList, parentForm, section);
            });
        }

        function searchRows(rowList, parentForm, parentSection) {
            _.each(rowList, function (row) {
                if (row.sectionList) {
                    searchSections(row.sectionList, row);
                }
                else if (row.rowStructureId === targetRowId) {
                    result = {
                        parentForm: parentForm,
                        parentSection: parentSection,
                        rowStructure: row
                    };
                }
            });
        }

        searchSections(sourceFormStructure.sectionList, sourceFormStructure);

        return result;
    }

    this.removeField = function (parentFieldStructureList, fieldStructure) {
        _.pull(parentFieldStructureList, fieldStructure);
    };

    this.removeRow = function (parentRowList, rowToRemove) {
        let rowIndexToRemove = _.findIndex(parentRowList, rowToRemove);
        parentRowList.splice(rowIndexToRemove, 1);
    };

    this.removeSection = function (parentSectionList, sectionToRemove) {
        _.pull(parentSectionList, sectionToRemove);
    };

    this.deleteField = function (formViewerInstance, elementToDeleteId) {
        let deleteTargetFieldStuctureLocation = findFieldStructureLocationById(elementToDeleteId, formViewerInstance.formStructure),
            parentRow = getFieldStructureLocationParentRow(deleteTargetFieldStuctureLocation);
        this.removeField(parentRow.fieldStructureList, deleteTargetFieldStuctureLocation.fieldStructure);
        this.removeField(parentRow.rowTemplate.fields, deleteTargetFieldStuctureLocation.fieldStructure.uiField);
        $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_FIELD, elementToDeleteId);
    };

    this.deleteSection = function (formViewerInstance, elementToDeleteId) {
        let deleteTargetFieldStuctureLocation = findSectionStructureLocationById(elementToDeleteId, formViewerInstance.formStructure);
        this.removeSection(deleteTargetFieldStuctureLocation.parentForm.sectionList, deleteTargetFieldStuctureLocation.sectionStructure);
        $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_SECTION, elementToDeleteId);
    };

    this.deleteRow = function (formViewerInstance, elementToDeleteId) {
        let deleteTargetRowLocation = findRowStructureLocationById(elementToDeleteId, formViewerInstance.formStructure);
        this.removeRow(deleteTargetRowLocation.parentSection.rowList, deleteTargetRowLocation.rowStructure);
        $rootScope.$broadcast(formViewerConstant.configuration.event.DELETE_ROW, elementToDeleteId);
    };

    this.moveField = function (formViewerInstance, elementToMoveId, dropZoneFieldId, moveType) {
        let isMoveLeft = moveType === formViewerConstant.configuration.INSERT_BEFORE,
            isMoveRight = moveType === formViewerConstant.configuration.INSERT_AFTER,
            isMoveIntoExistingRow = isMoveLeft || isMoveRight,
            isRowAdditionAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
            isRowAdditionBelow = moveType === formViewerConstant.configuration.INSERT_BELOW,
            isRowAddition = isRowAdditionAbove || isRowAdditionBelow,
            moveTargetFieldStructureLocation = findFieldStructureLocationById(elementToMoveId, formViewerInstance.formStructure),
            moveTargetParentRow = getFieldStructureLocationParentRow(moveTargetFieldStructureLocation),
            dropZoneFieldStructureLocation = findFieldStructureLocationById(dropZoneFieldId, formViewerInstance.formStructure),
            dropZoneParentRow = getFieldStructureLocationParentRow(dropZoneFieldStructureLocation),
            result = {
                removePreviousRow: false,
                movedElement: null,
                isRowRepeater: dropZoneFieldStructureLocation.isRowRepeater
            };

        function moveElementIntoExistingRow() {
            let dropZoneFieldStructureList = dropZoneParentRow.fieldStructureList,
                dropZoneTargetIndex = _.findIndex(dropZoneFieldStructureList, dropZoneFieldStructureLocation.fieldStructure),
                dropZoneRowTemplateFieldStructureList = dropZoneParentRow.rowTemplate.fields;

            if (isMoveRight) {
                dropZoneTargetIndex += 1;
            }

            moveTargetFieldStructureLocation.fieldStructure.hideLabel = dropZoneFieldStructureLocation.isRowRepeater;
            this.removeField(moveTargetParentRow.fieldStructureList, moveTargetFieldStructureLocation.fieldStructure);
            this.removeField(moveTargetParentRow.rowTemplate.fields, moveTargetFieldStructureLocation.fieldStructure.uiField);
            dropZoneFieldStructureList.splice(dropZoneTargetIndex, 0, moveTargetFieldStructureLocation.fieldStructure);
            dropZoneRowTemplateFieldStructureList.splice(dropZoneTargetIndex, 0, moveTargetFieldStructureLocation.fieldStructure.uiField);

            return moveTargetFieldStructureLocation.fieldStructure;
        }

        function createNewRowWithMovedField() {
            let rootFormId = moveTargetFieldStructureLocation.fieldStructure.rootFormId,
                newRowId = uuidUtil.generateUUID(),
                newRow = {
                    rootFormId: rootFormId,
                    rowStructureId: rootFormId + '-' + newRowId,
                    parentForm: moveTargetFieldStructureLocation.fieldStructure.parentForm,
                    parentFormStructure: moveTargetParentRow.parentFormStructure,
                    parentUiFormTemplate: moveTargetFieldStructureLocation.parentForm.uiFormTemplate,
                    rowTemplate: null,
                    fieldStructureList: [moveTargetFieldStructureLocation.fieldStructure],
                    rowHeight: moveTargetParentRow.rowHeight,
                    rowIdentifier: rootFormId + '-' + newRowId
                },
                dropZoneTargetRowList = dropZoneFieldStructureLocation.parentSection.rowList,
                dropZoneTargetRowIndex = _.findIndex(dropZoneTargetRowList, dropZoneFieldStructureLocation.parentRow);

            if (isRowAdditionBelow) {
                dropZoneTargetRowIndex += 1;
            }

            dropZoneTargetRowList.splice(dropZoneTargetRowIndex, 0, newRow);

            return newRow;
        }

        this.removeField(moveTargetParentRow.fieldStructureList, moveTargetFieldStructureLocation.fieldStructure);

        if (moveTargetParentRow.fieldStructureList.length === 0) {
            result.removePreviousRow = true;
            this.removeRow(moveTargetFieldStructureLocation.parentSection.rowList, moveTargetParentRow);
        }

        if (isMoveIntoExistingRow) {
            result.movedElement = moveElementIntoExistingRow.bind(this)();
            $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_MOVED_IN_ROW, result.movedElement);
        }
        else if (isRowAddition) {
            result.movedElement = createNewRowWithMovedField();
        }

        return result;
    };

    this.moveSection = function (formViewerInstance, elementToMoveSectionId, dropZoneSectionId, moveType) {
        let isMoveAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
            moveTargetSectionStructureLocation = findSectionStructureLocationById(elementToMoveSectionId, formViewerInstance.formStructure),
            dropZoneSectionStructureLocation = findSectionStructureLocationById(dropZoneSectionId, formViewerInstance.formStructure),
            dropZoneSectionStructureList,
            dropZoneTargetIndex;


        this.removeSection(moveTargetSectionStructureLocation.parentForm.sectionList, moveTargetSectionStructureLocation.sectionStructure);

        dropZoneSectionStructureList = dropZoneSectionStructureLocation.parentForm.sectionList;
        dropZoneTargetIndex = _.findIndex(dropZoneSectionStructureList, dropZoneSectionStructureLocation.sectionStructure);

        if (!isMoveAbove) {
            dropZoneTargetIndex += 1;
        }

        dropZoneSectionStructureList.splice(dropZoneTargetIndex, 0, moveTargetSectionStructureLocation.sectionStructure);

        return {
            movedElement: moveTargetSectionStructureLocation.sectionStructure
        };
    };

    this.moveRow = function (formViewerInstance, elementToMoveRowId, dropZoneRowId, moveType) {
        let isMoveAbove = moveType === formViewerConstant.configuration.INSERT_ABOVE,
            moveTargetRowStructureLocation = findRowStructureLocationById(elementToMoveRowId, formViewerInstance.formStructure),
            dropZoneRowStructureLocation = findRowStructureLocationById(dropZoneRowId, formViewerInstance.formStructure),
            dropZoneRowStructureList,
            dropZoneTargetIndex;

        this.removeRow(moveTargetRowStructureLocation.parentSection.rowList, moveTargetRowStructureLocation.rowStructure);

        dropZoneRowStructureList = dropZoneRowStructureLocation.parentSection.rowList;
        dropZoneTargetIndex = _.findIndex(dropZoneRowStructureList, dropZoneRowStructureLocation.rowStructure);

        if (!isMoveAbove) {
            dropZoneTargetIndex += 1;
        }

        dropZoneRowStructureList.splice(dropZoneTargetIndex, 0, moveTargetRowStructureLocation.rowStructure);

        return {
            movedElement: moveTargetRowStructureLocation.rowStructure
        };
    };

    function getFieldStructureLocationParentRow(fieldStructureLocation){
        return _.isNil(fieldStructureLocation.parentRow.rowList) ? fieldStructureLocation.parentRow : fieldStructureLocation.parentRow.rowList[0];
    }
};

angular.module('umFormViewer')
    .service('formConfigurationUtil', FormConfigurationUtil);
